import { useState } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const faqs = [
  {
    q: 'Это чат-бот?',
    a: 'Нет. AIGAM не просто отвечает на сообщения. Он самостоятельно находит клиентов в открытых Telegram-чатах, начинает диалог в личных сообщениях, квалифицирует лидов и назначает встречи.',
  },
  {
    q: 'Можно выбрать только свою нишу?',
    a: 'Да. При настройке вы указываете ключевые слова и направления, по которым система будет искать запросы. Можно настроить фильтрацию по городам, бюджету и тематике.',
  },
  {
    q: 'ИИ ведёт диалог самостоятельно?',
    a: 'Да. AIGAM анализирует контекст запроса и формирует персональный ответ. Задаёт уточняющие вопросы, квалифицирует клиента и согласовывает встречу. Вам передаётся только готовый заинтересованный лид.',
  },
  {
    q: 'Подходит ли для агентств?',
    a: 'Абсолютно. Тариф AGENCY создан специально для маркетинговых агентств, студий разработки и других команд с несколькими клиентами. Поддерживается командный доступ и интеграции с CRM.',
  },
  {
    q: 'Что с приватностью и правилами Telegram?',
    a: 'Система работает только с публичными сообщениями из открытых Telegram-чатов. Мы не используем личную переписку и не собираем данные пользователей. Все действия соответствуют политике Telegram.',
  },
  {
    q: 'Как происходит подключение?',
    a: 'После заявки на демо мы показываем вам реальные запросы из вашей ниши за последние 24 часа. После подтверждения — настройка под ключ занимает 1 рабочий день.',
  },
];

export default function TLFAQ() {
  const [openIdx, setOpenIdx] = useState(0);
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });

  return (
    <section id="faq" className="bg-background-50 py-20 md:py-28 border-t border-background-200">
      <div className="max-w-[1080px] mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span
            ref={labelRef}
            className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
          >
            FAQ
          </span>
          <h2
            ref={titleRef}
            className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
          >
            Частые вопросы
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className={`rounded-xl border transition-colors ${isOpen ? 'border-foreground-900 bg-background-100' : 'border-background-200 bg-background-50'}`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                >
                  <span className="font-display font-bold text-[16px] md:text-[18px] text-foreground-950">
                    {faq.q}
                  </span>
                  <span
                    className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 transition-all ${isOpen ? 'bg-primary-500 text-background-50 rotate-180' : 'bg-background-200 text-foreground-700'}`}
                  >
                    <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 -mt-1 text-[15px] text-foreground-600 leading-relaxed fade-up">
                    {faq.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}